"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DurableHttpResponse {
    constructor(statusCode, content, headers) {
        this.statusCode = statusCode;
        this.content = content;
        this.headers = headers;
    }
    getHeader(name) {
        if (this.headers) {
            const lowerCaseName = name.toLowerCase();
            const foundKey = Object.keys(this.headers).find((key) => key.toLowerCase() === lowerCaseName);
            if (foundKey) {
                return this.headers[foundKey];
            }
        }
        return undefined;
    }
}
exports.DurableHttpResponse = DurableHttpResponse;
//# sourceMappingURL=durablehttpresponse.js.map